module.exports = __webpack_public_path__ + "media/packs/landing_page/images/studios/barralates-41e7aa103a926f7f571012653187e626.png";